module.exports = "../dist/img/img_4-18.945b.jpg";